import React from 'react';
import { I18n } from '../../core/i18n/I18n';

var EmptyBodyRow = function EmptyBodyRow(_ref) {
  var colSpan = _ref.colSpan;
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center",
    colSpan: colSpan
  }, /*#__PURE__*/React.createElement("em", null, /*#__PURE__*/React.createElement(I18n, null, "No data found."))));
};

export default EmptyBodyRow;